import { render, staticRenderFns } from "./AgregarGeneracion.vue?vue&type=template&id=00633140"
import script from "./AgregarGeneracion.vue?vue&type=script&lang=js"
export * from "./AgregarGeneracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports